import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  standalone: true,
  imports: [
    MatIconModule,
    CommonModule
  ],
  selector: 'humanize-state',
  templateUrl: './humanize-state.component.html',
  styleUrls: ['./humanize-state.component.css']
})
export class HumanizeStateComponent implements OnInit {

  @Input() state;
  @Input() parent;
  constructor() { }

  ngOnInit(): void {

  }

  get description() {
    if (this.parent && this.state === 'IN_PROGRESS') {
      return 'Reabierto';
    }
    switch (this.state) {
      case 'IN_PROGRESS':
        return 'En curso'
        break;
      case 'REJECTED':
        return 'Rechazado'
        break;
      case 'COMPLETED':
      case 'CLOSED':
        return 'Cerrado'
        break;
      case 'NEW':
        return 'Pendiente'
        break;
      case 'TRIAGE':
        return 'Pendiente de clasificar'
      default:
        return ''
        break;
    }
  }

}
